import { migration as initial } from "./001_initial";
import { migration as customers } from "./002_customers";
import { migration as dropCustomers } from "./003_drop_customers";
import { migration as addLeadNumbering } from "./004_add_lead_numbering";
export const migrations = [initial, customers, dropCustomers, addLeadNumbering];
